import { ReactComponent as InformationIcon } from '../../assets/information.svg';
import React from 'react';
export interface InformationCardProps {
  children: JSX.Element[] | JSX.Element;
}
export default function InformationCard({ children }: InformationCardProps) {
  return (
    <article className="information-card">
      <div className="information-card__icon">
        <InformationIcon />
      </div>
      <div className="information-card__body">{children}</div>
    </article>
  );
}
